import { Fragment } from "react";

import LegalPageContent from "../common/LegalPageContent";

const TermConditionModal = () => {
  return (
    <Fragment>
      <LegalPageContent slug="terms-condition" />
    </Fragment>
  );
};

export default TermConditionModal;
